/**
 * Fixed app-wide chrome that other viewport-anchored surfaces have to clear.
 */

/**
 * Height of the `RecordingMiniBar` — the full-width bar pinned to the bottom of
 * every page while a recording is minimised
 * (`components/ai-scribe/recording-flow/recording-mini-bar.tsx`).
 *
 * This is the single source of truth for that height: the bar sets its own
 * `height` from this constant, and the app-wide toaster lifts its stack by it so
 * a toast never lands on the bar's pause/stop controls. A Tailwind arbitrary
 * value (`h-[55px]`) cannot be driven from a constant, so binding both sides to
 * this number is what keeps them from drifting apart.
 */
export const RECORDING_MINI_BAR_HEIGHT_PX = 55;
